import { ACTION_TYPES as SHOP_ACTION_TYPES } from '../constants/actions';
import { ApiLog, Error } from '../types/tracker';
import { Dispatch } from 'redux';
import { getShortenUrl } from '../helpers/common';
import isFeatureFlagEnabled from '../helpers/feature-flags';
import { FEATURE_FLAG_ENABLE_FE_LOG } from '../types/featureFlag.types';

export interface LogState {
  userJourney: string[];
  apiLogs: string[];
  shouldSendLog: boolean;
  error?: Error;
}

interface LogAction {
  value?: SendLogValue | ApiLog | string;
  type: string;
}

interface SendLogValue {
  shouldSendLog: boolean;
  error?: Error;
}

const initialState: LogState = {
  userJourney: [],
  apiLogs: [],
  shouldSendLog: false
};

export const logReducer = (
  state: LogState = initialState,
  action: LogAction
): LogState => {
  switch (action.type) {
    case SHOP_ACTION_TYPES.LOGS.SEND_LOGS: {
      const { shouldSendLog, error } = (action.value as SendLogValue) || {};
      return {
        ...state,
        shouldSendLog,
        error
      };
    }
    case SHOP_ACTION_TYPES.LOGS.PUSH_API_LOG: {
      const { status, url } = (action.value as ApiLog) || {};
      return {
        ...state,
        apiLogs: [...state.apiLogs, `${getShortenUrl(url, false)}-${status}`]
      };
    }
    case SHOP_ACTION_TYPES.LOGS.PUSH_USER_JOURNEY: {
      return {
        ...state,
        userJourney: [
          ...state.userJourney,
          getShortenUrl(action.value as string)
        ]
      };
    }
    case SHOP_ACTION_TYPES.LOGS.RESET_LOG: {
      return initialState;
    }

    default:
      return state;
  }
};

export const setSendLog = (shouldSendLog: boolean, error?: Error) => (
  dispatch: Dispatch
) => {
  if (isFeatureFlagEnabled(FEATURE_FLAG_ENABLE_FE_LOG)) {
    dispatch({
      type: SHOP_ACTION_TYPES.LOGS.SEND_LOGS,
      value: { shouldSendLog, error }
    });
  }
};

export const pushApiLog = (api: ApiLog) => (dispatch: Dispatch) => {
  if (isFeatureFlagEnabled(FEATURE_FLAG_ENABLE_FE_LOG)) {
    dispatch({ type: SHOP_ACTION_TYPES.LOGS.PUSH_API_LOG, value: api });
  }
};

export const pushUserJourney = (url: string) => (dispatch: Dispatch) => {
  if (isFeatureFlagEnabled(FEATURE_FLAG_ENABLE_FE_LOG)) {
    dispatch({ type: SHOP_ACTION_TYPES.LOGS.PUSH_USER_JOURNEY, value: url });
  }
};

export const resetLogs = () => (dispatch: Dispatch) => {
  if (isFeatureFlagEnabled(FEATURE_FLAG_ENABLE_FE_LOG)) {
    dispatch({ type: SHOP_ACTION_TYPES.LOGS.RESET_LOG });
  }
};
